import { Toggle } from "components/ui/toggle";
import {
  addChip,
  chipEvents,
  isChipActive,
  quickFiltersFor,
  removeChip,
} from "@/components/views/auditLogQuickFiltersHelper";

/**
 * The Activity Log's quick-filter chips. Each chip toggles a set of event
 * types through the same `onApply` the Filters panel uses, so it adds to or
 * removes from the panel's selection rather than replacing it.
 */
export function AuditLogQuickFilters({
  modelType,
  filters,
  filterKeys,
  queryParams,
  onApply,
  isLoading = false,
}) {
  const quickFilters = quickFiltersFor(modelType);
  // Which chips apply is unknown until the options arrive, so the full set
  // stands in, disabled, while they load.
  const chips = isLoading
    ? quickFilters.map(chip => ({ ...chip, events: [] }))
    : quickFilters
        .map(chip => ({
          ...chip,
          events: chipEvents(chip, filters),
        }))
        .filter(chip => chip.events.length > 0);

  if (!chips.length) return null;

  return (
    <div className="tw:flex tw:flex-wrap tw:items-center tw:justify-end tw:gap-2">
      {chips.map(({ key, label, icon: Icon, events }) => {
        const active = isChipActive(events, queryParams);
        const updateChip = active ? removeChip : addChip;
        return (
          <Toggle
            key={key}
            variant="outline"
            disabled={isLoading}
            pressed={active}
            onPressedChange={() =>
              onApply(updateChip(events, queryParams, filterKeys))
            }
            size="sm"
            className="tw:hover:border-primary tw:hover:bg-primary tw:hover:text-primary-foreground tw:aria-pressed:border-primary tw:aria-pressed:bg-primary tw:aria-pressed:text-primary-foreground tw:aria-pressed:hover:bg-primary/80"
          >
            <Icon data-icon="inline-start" />
            {label}
          </Toggle>
        );
      })}
    </div>
  );
}
